// extracted by mini-css-extract-plugin
export default {"main":"fyW692PnZASZv5pc9yEA","cropper":"sLEWXnYNYAYEPMr1SFid","footer":"SHTb3oDsAIVHPS9qFNJQ"};